import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Login from '../../../../pages/Login/Login'
import EntityDetails from '../../../../pages/Entities/EntityDetails/EntityDetails'
import RedirectToDashboard from '../RedirectToDashboard/RedirectToDashboard'
import Entity from '../../../../pages/Entities/Entities'
import router from '../../../../utils/router'
import Trade from '../../../../pages/Trade/Trade'
import Deal from '../../../../pages/Deal/Deal'

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {router.map((route, index) => {
        const { path, element } = route
        return <Route key={index} path={path} element={element} />
      })}
      <Route path="/trade" element={<Trade />} />
      <Route path="/deal" element={<Deal />} />

      <Route path="/entities" element={<Entity />} />
      <Route
        path="/entities/:entityId/:counterpartyType/:tradingAccountId"
        element={<EntityDetails />}
      />
      <Route path="/entities/:entityId" element={<EntityDetails />} />
      <Route path="*" element={<RedirectToDashboard />} />
    </Routes>
  )
}

export default PrivateRoutes
